import React from "react";

const Contact = () => {
  return (
    <div id="fh5co-contact">
      <div className="container">
        <div className="row animate-box">
          <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
            <h2>Connect</h2>
            <p>For professional inquiries, connect with me through LinkedIn or GitHub.</p>
            <p>
              <a
                href="https://linkedin.com/in/catchashu10"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary btn-md"
              >
                LinkedIn
              </a>{" "}
              <a
                href="https://github.com/catchashu10"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-default btn-md"
              >
                GitHub
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
